import { useMemo } from 'react'
import isAfter from 'date-fns/isAfter'
import isBefore from 'date-fns/isBefore'
import endOfToday from 'date-fns/endOfToday'

const useIsAfterLastOrder = (now: Date, lastOrderDateTime: Date): boolean => {
  return useMemo(() => {
    return isAfter(now, lastOrderDateTime) && isBefore(now, endOfToday())
  }, [now, lastOrderDateTime])
}

export default useIsAfterLastOrder
